import { get, post } from "../../../services/request";

export const exportToCSV = (exportAPIURL) => {
    return get(exportAPIURL);
};

export const getDashboardDetails = () => {
    return get('Common/GetDashboardDetails');
};

// Pending requests per day by Start Date. Dates are YYYY-MM-DD: endDate omitted = today,
// startDate omitted = 2 days before endDate (the tile's 3-day window)
export const getProviderRequestDailyCounts = (endDate, startDate) => {
    return get('Common/GetProviderRequestDailyCounts', {
        ...(endDate && { endDate }),
        ...(startDate && { startDate }),
    });
};

export const getQgendaTasksAndSchedules = (data) => {
    return post('Qgenda/GetQgendaTasksAndSchedules', data);
};

export const getAllowedMenus = () => {
    return get('MainModules/GetAllowedMenus');
};

export const exportToCSVWithPost = (exportAPIURL, payload) => {
    return post(exportAPIURL, payload);
};
export const getAssignedSitesCount = () => {
    return get('SiteManagement/GetAssignedSitesCount');
};

export const getUnassignedSitesCount = () => {
    return get('SiteManagement/GetNoOfUnAssignedSites');
}

export const getAssignedRolesWithPractices = () => {
    return get('AdvancedSchedulingCommon/GetAllAssignedRolesWithPractices');
}

export const getTenantConfiguration = (serverUrl) => {
    return get(`Coaxion/TenantConfiguration/GetByServerUrl?serverUrl=${encodeURIComponent(serverUrl)}`);
};

export const getTimezone = (tenantId) => {
    return get(`Common/GetTenantTimeZone?tenantId=${tenantId}`);
};
export const getDefaultWorklists = () => {
    return get('WorklistDefinition/GetDefaultWorklists');
};
